import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { getGData } from "./ggame";
import { loadingStart, loadingSuccess, loadingFailure } from "./loading";

const initialState = {
  user: null,
  loading: false,
  data: null,
  error: null,
};

const authCreateSlice = createSlice({
  name: "createauth",
  initialState,
  reducers: {
    requestStart: (state, action) => {
      state.loading = true;
      state.data = action.payload;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.user = null;
    },
  },
});

// Actions
export const { requestStart, ApiSuccess, requestFailure,  } =
  authCreateSlice.actions;

export const CreateAuthSlice = (data) => async (dispatch) => {
  try {
    dispatch(loadingStart());
    dispatch(requestStart(data));

    const response = await axios.post(`/private/user/generate`, data);
    if (response.status === 200) {
      dispatch(ApiSuccess(response.data));
      dispatch(getGData());
      toast.success("Created successfully!");
      dispatch(loadingSuccess("Created successfully!"));
    } else if (response.status === 202) {
      dispatch(ApiSuccess(response.data));
      dispatch(getGData());
      dispatch(loadingSuccess("Created successfully!"));
    }
  } catch (err) {
    // Handle errors
    toast.error(err?.response?.data?.message || err.message || "Login failed!");
    dispatch(loadingFailure());
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default authCreateSlice.reducer;
